import { type Location, useParams } from 'react-router-dom';

import { AppRoute } from '@/common/app/routes';
import { selectQuarryByResourceNameOrId } from '@/redux/selectors/common';
import { useAppSelector } from '@/redux/store';

import { type HelpTextType } from './HelpTextConfig';
import { helpTextTypesArray } from './helpTypesArray';
import useBoostHelp from './useBoostHelp';

const useHelpTypeFunction = (location: Location): HelpTextType | undefined => {
  const { id } = useParams();
  const quarry = useAppSelector((state) =>
    selectQuarryByResourceNameOrId(state, id),
  );

  if (useBoostHelp()) return 'boosts';

  if (
    location.pathname.includes('/upgrade') ||
    location.pathname.includes('/build')
  ) {
    return 'build_upgrade';
  }

  if (!quarry) {
    switch (location.pathname) {
      case AppRoute.MAIN:
        return 'main';
      case AppRoute.RESOURCES:
        return 'resources';
      case AppRoute.FACTORY:
        return 'plants';
      case AppRoute.WORKSHOP:
        return 'factories';
      case AppRoute.STOCK:
        return 'stock';
      case AppRoute.PARTNERS:
        return 'partners';
      case AppRoute.FRIENDS:
        return 'friends';
      case AppRoute.EARN:
        return 'earn';
      default:
        return undefined;
    }
  }

  if (quarry && helpTextTypesArray.includes(quarry.name as HelpTextType))
    return quarry.name as HelpTextType;
};

export { useHelpTypeFunction };
